module.exports = __webpack_public_path__ + "static/media/pic4.54d227a7.jpeg";